import type { ReactNode } from 'react'
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded'
import { Button } from '../Common/Button'

export type SetupStepFooterProps = {
  onBack?: () => void
  backDisabled?: boolean
  className?: string
  children?: ReactNode
}

export const SetupStepFooter = ({
  onBack,
  backDisabled = false,
  className,
  children,
}: SetupStepFooterProps) => {
  return (
    <footer className={['setupCard__foot', className].filter(Boolean).join(' ')}>
      {onBack && (
        <Button
          variant="tertiary"
          size="sm"
          icon={<ArrowBackRoundedIcon />}
          onClick={onBack}
          disabled={backDisabled}
        >
          Back
        </Button>
      )}
      <div className="setupCard__footPrimary">{children}</div>
    </footer>
  )
}
